export default class UploadAttachmentController {
  handleFileUploaded(file) {
    const result = {
      label: file.name,
      file_size: file.size,
      document: file,
      can_remove: true,
    };
    this.confirm({result: result});
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/tasks/screens/task-detail/screens/task-detail-info/components/upload-attachment/upload-attachment.controller.js